<template>
  <b-modal
    id="preview-creative-modal"
    ref="previewCreativeModal"
    :title="$tk('ClientPortal.Form.Gallery')"
    scrollable
    :cancel-title="$tk('ClientPortal.Form.Actions.Close')"
    cancel-variant="outline-secondary"
    :ok-disabled="true"
    centered
    modal-class="no-confirm-button"
    :size="creative.width > 800 ? 'xl' : creative.width < 400 ? 'md' : 'lg'"
    @cancel="closeGalleryPreview"
  >
    <div class="catalog-items mb-0">
      <div class="text-center mb-0">
        <div v-if="creative.creativeType == 1">
          <img
            :src="creative.url"
            :style="'{ width: '+creative.width +'}'"
          >
        </div>
        <div v-else>
          <iframe
            :src="creative.url"
            :height="creative.height"
            :width="creative.width"
            frameborder="0"
            scrolling="auto"
          />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    creative: {
      type: Object,
      default: null,
    },
  },
  methods: {
    previewCreative() {
      this.$refs.previewCreativeModal.show()
    },
    closeGalleryPreview() {
      this.$refs.previewCreativeModal.hide()
    },
  },
}
</script>
